export const mockRecipes = [
  {
    id: 1,
    title: "Mediterranean Quinoa Bowl",
    description: "A nutritious and colorful bowl packed with Mediterranean flavors, featuring quinoa, fresh vegetables, and a tangy lemon dressing.",
    image: "https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=500&h=300&fit=crop",
    cookTime: "25 mins",
    servings: 4,
    difficulty: "Easy",
    cuisine: "Mediterranean",
    ingredients: [
      "1 cup quinoa",
      "2 cups vegetable broth",
      "1 cucumber, diced",
      "2 tomatoes, chopped",
      "1/2 red onion, sliced",
      "1/2 cup kalamata olives",
      "1/2 cup feta cheese, crumbled",
      "1/4 cup olive oil",
      "2 tbsp lemon juice",
      "2 cloves garlic, minced",
      "1 tsp oregano",
      "Salt and pepper to taste"
    ],
    instructions: [
      "Rinse quinoa and cook in vegetable broth according to package directions.",
      "While quinoa cooks, prepare vegetables by dicing cucumber, chopping tomatoes, and slicing onion.",
      "Make dressing by whisking together olive oil, lemon juice, minced garlic, oregano, salt, and pepper.",
      "Once quinoa is cooked and cooled slightly, combine with prepared vegetables and olives.",
      "Drizzle with dressing and toss gently to combine.",
      "Top with crumbled feta cheese and serve immediately."
    ],
    nutrition: {
      calories: "320 kcal",
      protein: "12g",
      carbs: "45g",
      fat: "12g",
      fiber: "6g",
      sodium: "480mg"
    },
    tags: ["Vegetarian", "Gluten-Free", "Mediterranean", "Healthy"],
    likes: 156,
    comments: 23,
    shares: 12,
    author: {
      name: "HealthyChef92",
      avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=chef1",
      recipes: 45
    }
  },
  {
    id: 2,
    title: "Spicy Thai Basil Chicken",
    description: "An authentic Thai stir-fry with ground chicken, fresh basil, and a perfect balance of sweet, salty, and spicy flavors.",
    image: "https://images.unsplash.com/photo-1559847844-d721426d6edc?w=500&h=300&fit=crop",
    cookTime: "15 mins",
    servings: 2,
    difficulty: "Medium",
    cuisine: "Thai",
    ingredients: [
      "1 lb ground chicken",
      "3 cloves garlic, minced",
      "2 Thai chilies, sliced",
      "1 cup fresh Thai basil leaves",
      "2 tbsp vegetable oil",
      "2 tbsp fish sauce",
      "1 tbsp soy sauce",
      "1 tsp sugar",
      "1 onion, sliced",
      "1 bell pepper, sliced",
      "Jasmine rice for serving"
    ],
    instructions: [
      "Heat oil in a wok or large skillet over high heat.",
      "Add garlic and chilies, stir-fry for 30 seconds until fragrant.",
      "Add ground chicken and cook, breaking it up, until no longer pink.",
      "Add onion and bell pepper, stir-fry for 2-3 minutes.",
      "Mix in fish sauce, soy sauce, and sugar.",
      "Remove from heat and stir in fresh basil leaves until wilted.",
      "Serve immediately over jasmine rice."
    ],
    nutrition: {
      calories: "285 kcal",
      protein: "28g",
      carbs: "8g",
      fat: "15g",
      fiber: "2g",
      sodium: "890mg"
    },
    tags: ["Spicy", "Thai", "High-Protein", "Quick"],
    likes: 203,
    comments: 31,
    shares: 18,
    author: {
      name: "SpicyFoodie88",
      avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=chef2",
      recipes: 67
    }
  },
  {
    id: 3,
    title: "Vegan Chocolate Avocado Mousse",
    description: "A rich and creamy chocolate mousse made with avocados - you'd never guess it's vegan and incredibly healthy!",
    image: "https://images.unsplash.com/photo-1541781774459-bb2af2f05b55?w=500&h=300&fit=crop",
    cookTime: "10 mins",
    servings: 4,
    difficulty: "Easy",
    cuisine: "Dessert",
    ingredients: [
      "3 ripe avocados",
      "1/4 cup cocoa powder",
      "1/4 cup maple syrup",
      "2 tbsp almond butter",
      "1 tsp vanilla extract",
      "Pinch of salt",
      "2-3 tbsp almond milk",
      "Fresh berries for garnish",
      "Mint leaves for garnish"
    ],
    instructions: [
      "Cut avocados in half, remove pits, and scoop flesh into a food processor.",
      "Add cocoa powder, maple syrup, almond butter, vanilla, and salt.",
      "Process until smooth and creamy, about 2-3 minutes.",
      "Add almond milk gradually until desired consistency is reached.",
      "Taste and adjust sweetness if needed.",
      "Divide into serving bowls and refrigerate for at least 30 minutes.",
      "Garnish with fresh berries and mint before serving."
    ],
    nutrition: {
      calories: "195 kcal",
      protein: "4g",
      carbs: "18g",
      fat: "14g",
      fiber: "8g",
      sodium: "45mg"
    },
    tags: ["Vegan", "Dessert", "Healthy", "No-Bake"],
    likes: 342,
    comments: 45,
    shares: 28,
    author: {
      name: "VeganSweets",
      avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=chef3",
      recipes: 89
    }
  },
  {
    id: 4,
    title: "Keto Salmon with Asparagus",
    description: "A perfect keto dinner featuring herb-crusted salmon with roasted asparagus and a lemon butter sauce.",
    image: "https://images.unsplash.com/photo-1467003909585-2f8a72700288?w=500&h=300&fit=crop",
    cookTime: "20 mins",
    servings: 2,
    difficulty: "Medium",
    cuisine: "American",
    ingredients: [
      "2 salmon fillets (6 oz each)",
      "1 lb asparagus, trimmed",
      "3 tbsp olive oil",
      "2 tbsp butter",
      "2 cloves garlic, minced",
      "1 lemon, juiced and zested",
      "1 tsp dried dill",
      "1 tsp paprika",
      "Salt and pepper to taste",
      "Fresh parsley for garnish"
    ],
    instructions: [
      "Preheat oven to 400°F (200°C).",
      "Season salmon with salt, pepper, dill, and paprika.",
      "Heat 1 tbsp olive oil in an oven-safe skillet over medium-high heat.",
      "Sear salmon skin-side up for 3-4 minutes, then flip and transfer to oven.",
      "Toss asparagus with remaining olive oil, salt, and pepper on a baking sheet.",
      "Roast salmon and asparagus for 10-12 minutes.",
      "Meanwhile, melt butter with garlic and lemon juice in a small pan.",
      "Serve salmon and asparagus drizzled with lemon butter sauce."
    ],
    nutrition: {
      calories: "420 kcal",
      protein: "35g",
      carbs: "6g",
      fat: "28g",
      fiber: "3g",
      sodium: "320mg"
    },
    tags: ["Keto", "Low-Carb", "High-Protein", "Seafood"],
    likes: 189,
    comments: 27,
    shares: 15,
    author: {
      name: "KetoKitchen",
      avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=chef4",
      recipes: 52
    }
  },
  {
    id: 5,
    title: "Classic Italian Margherita Pizza",
    description: "Authentic Neapolitan-style pizza with fresh mozzarella, basil, and San Marzano tomatoes on a perfectly crispy crust.",
    image: "https://images.unsplash.com/photo-1565299624946-b28f40a0ca4b?w=500&h=300&fit=crop",
    cookTime: "45 mins",
    servings: 4,
    difficulty: "Hard",
    cuisine: "Italian",
    ingredients: [
      "Pizza dough (homemade or store-bought)",
      "1/2 cup San Marzano tomatoes, crushed",
      "8 oz fresh mozzarella, sliced",
      "Fresh basil leaves",
      "2 tbsp extra virgin olive oil",
      "2 cloves garlic, minced",
      "Salt and pepper to taste",
      "Semolina flour for dusting"
    ],
    instructions: [
      "Preheat oven to 500°F (260°C) with pizza stone if available.",
      "Mix crushed tomatoes with garlic, salt, and pepper for sauce.",
      "Roll out pizza dough on floured surface to 12-inch circle.",
      "Transfer to pizza stone or baking sheet dusted with semolina.",
      "Spread thin layer of tomato sauce, leaving 1-inch border for crust.",
      "Add mozzarella slices evenly across pizza.",
      "Bake for 10-12 minutes until crust is golden and cheese is bubbly.",
      "Remove from oven, add fresh basil and drizzle with olive oil."
    ],
    nutrition: {
      calories: "380 kcal",
      protein: "18g",
      carbs: "45g",
      fat: "15g",
      fiber: "3g",
      sodium: "720mg"
    },
    tags: ["Italian", "Vegetarian", "Pizza", "Classic"],
    likes: 267,
    comments: 38,
    shares: 22,
    author: {
      name: "ItalianNonna",
      avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=chef5",
      recipes: 78
    }
  }
];

export const mockComments = [
  {
    id: 1,
    recipeId: 1,
    author: {
      name: "FoodLover123",
      avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=user1"
    },
    content: "This looks absolutely delicious! Can't wait to try it this weekend.",
    timestamp: "2 hours ago",
    likes: 5
  },
  {
    id: 2,
    recipeId: 1,
    author: {
      name: "HealthyEater",
      avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=user2"
    },
    content: "Made this last night and it was amazing! The whole family loved it.",
    timestamp: "1 day ago",
    likes: 12
  }
];
